// extracted by mini-css-extract-plugin
export default {"root":"_1vEDh","white":"_1SjJ5","themed":"Tgk1x"};